// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"193d6953","186":"ed2b5188","225":"fbad1ac2","344":"13b61b83","372":"fa8dcfec","738":"1935b2e4","841":"0e97724d","856":"8edab5b7"}[chunkId] + ".chunk.js";
};